export default class ScriptLoader {
    constructor(options) {
        const {
            src = null,
            type = 'text/javascript',
            async = true,
            defer = true,
            inHead = false
        } = options;

        if (!src) {
            throw new Error('The provided "src" value is invalid.');
        }

        this.loaded = false;
        this.src = src;
        this.type = type;
        this.async = async;
        this.defer = defer;
        this.inHead = inHead;
    }

    Load() {
        return new Promise((resolve, reject) => {
            if (!this.loaded) {
                try {
                    this._LoadScript().then(() => {
                        resolve();
                    });
                }
                catch (e) {
                    reject(e);
                }
            }
            else {
                resolve();
            }
        });
    }

    _LoadScript() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = this.src;
            script.type = this.type;
            script.async = this.async;
            script.defer = this.defer;

            if (this.inHead) {
                document.head.appendChild(script);
            } else {
                document.body.appendChild(script);
            }
            script.addEventListener('load', () => {
                this.loaded = true;
                resolve();
            });

            script.addEventListener('error', () => {
                reject(new Error(`${this.src} failed to load.`));
            });
        });
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Core/ScriptLoader.js